module.exports = __webpack_public_path__ + "img/success.dd090c2c.svg";